import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';

import { decodeFormValue } from 'utils/forms';

class LimitedTextarea extends Component {
    static propTypes = {
        fieldName: PropTypes.string.isRequired,
        fieldValue: PropTypes.string,
        className: PropTypes.string,
        rows: PropTypes.number,
        cols: PropTypes.number,
        countShow: PropTypes.bool,
        countLimit: PropTypes.number,
    };

    static defaultProps = {
        className: 'textarea form-control',
        fieldValue: '',
        rows: 10,
        cols: 40,
        countShow: false,
        countLimit: 2000,
    };

    constructor(props) {
        super(props);
        const { fieldValue } = this.props;

        this.textareaRef = React.createRef();
        this.state = {
            count: this.countCharacters(decodeFormValue(fieldValue)),
        };
    }

    // Treat windows-style line endings as single character
    countCharacters = (value) => value.replace(/\r\n/gi, '\n').length;

    checkInput = () => {
        this.setState({ count: this.countCharacters(this.textareaRef.current.value) });
    };

    render() {
        const { fieldName, fieldValue, className, rows, cols, countShow, countLimit } = this.props;
        const { count } = this.state;
        return (
            <Fragment>
                <textarea
                    name={fieldName}
                    className={className}
                    rows={rows}
                    cols={cols}
                    defaultValue={decodeFormValue(fieldValue)}
                    onChange={countShow ? this.checkInput : undefined}
                    maxLength={countLimit}
                    ref={this.textareaRef}
                />
                {countShow && (
                    <div className="textarea-character-count">
                        {count}/{countLimit}
                    </div>
                )}
            </Fragment>
        );
    }
}

export default LimitedTextarea;



// WEBPACK FOOTER //
// ./src/components/LimitedTextarea.js